import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FileDropZone } from './FileDropZone';
import { FileDropZoneSignatureProgress } from './FileDropZoneSignatureProgress';
import { useStores } from '../../stores/Hooks';
import { FileStateEnum } from '../../models/FileStateEnum';

interface IFileDropZoneSignature
{
	/** Текст внутри кнопки */
	ButtonText?: string,

	/** Текст рядом с кнопкой */
	DescriptionText?: string,

	/** Разрешенные для дропания типы файлов */
	Accept?: string,

	/** Разрешенные расширения файлов */
	AllowedExtensions: string[]
}

export const FileDropZoneSignature: React.FC<IFileDropZoneSignature> = observer(
	(
		{
			ButtonText = "Выберите файл",
			DescriptionText = "Выберите файл или перетащите сюда файл для загрузки",
			Accept = "",
			AllowedExtensions
		}: IFileDropZoneSignature
	) =>
	{
		const { uiState, dataState } = useStores();
		const store = uiState.stat;

		const FileDropZoneOnDrop = (acceptedFiles: File[]) =>
		{
			if (acceptedFiles.length !== 1)
			{
				store.setDownloadingSignFileError("Разрешено добавлять только одну подпись");
				return;
			}

			let f: File = acceptedFiles[0];

			let ext: string | undefined = "";
			if (f.name)
			{
				let sp: string[] = f.name.split('.');
				if (sp.length > 1) ext = sp.pop();
			}
			if (!ext)
			{
				store.setDownloadingSignFileError("Ошибка загрузки файла. Разрешено добавлять файл только<br />следующих типов " + AllowedExtensions.join(", ") + ". Загрузите файл повторно");
				return;
			}

			if (AllowedExtensions.indexOf(ext) < 0)
			{
				store.setDownloadingSignFileError("Ошибка загрузки файла. Разрешено добавлять файл только<br />следующих типов " + AllowedExtensions.join(", ") + ". Загрузите файл повторно");
				return;
			}
			if (f.size + uiState.files.CurrentStorageSize >= uiState.files.MaxStorageSize)
			{
				store.setDownloadingSignFileError("Ваши файлы займут слишком много места.");
				return;
			}

			store.setDownloadingSignFile(f);
			store.UploadSign(f);
		}

		function dataStatus()
		{
			switch (store.DownloadingSignFileState)
			{
				case FileStateEnum.Started: return "in-progress";
				case FileStateEnum.Faulted: return "error";
				case FileStateEnum.Succeed: return "complete";
				case FileStateEnum.Waiting: return "waiting";
			}
		}


		return (
			<div className="modal-file">
				<p>Файл подписи руководителя организации</p>
				{(store.DownloadingSignFileState === FileStateEnum.None || store.DownloadingSignFileState === FileStateEnum.Faulted) &&
					<FileDropZone Disabled={uiState.IsDisabled} ButtonText={ButtonText} DescriptionText={DescriptionText} TipText={uiState.modal.ParseBR(store.DownloadingSignFileError)} Accept={Accept} OnDropAction={FileDropZoneOnDrop} IsError={store.DownloadingSignFileError !== ""} TipClass="text-danger" />
				}
				{(store.DownloadingSignFileState !== FileStateEnum.None && store.DownloadingSignFileState !== FileStateEnum.Faulted && store.DownloadingSignFile!==null) &&
					<div className="file-cards">
						<div className="file-card d-flex align-items-center" data-status={dataStatus()}>
							<div className="file-card__info d-flex align-items-center">
								<div className="file-card__data">
									<div className="file-card__filename mb-1">
										<a download="Заявление_оператора_ЭДО.sgn" href={dataState.GetSgnFileLink()} target="_blank" rel="noopener noreferrer nofollow">
											{store.DownloadingSignFile.name}
										</a>
									</div>
									<div className="file-card__status">
										<div className="in-progress" style={{ display: store.DownloadingSignFileState === FileStateEnum.Started ? "block" : "none" }}>
											<div className="d-flex align-items-center">
												<div className="in-progress__size f-14">{uiState.files.shortFileSize(store.DownloadingSignFile.size)}</div>
												<FileDropZoneSignatureProgress />
											</div>
										</div>
										<div className="complete" style={{ display: store.DownloadingSignFileState === FileStateEnum.Succeed ? "block" : "none" }}>
											<div className="d-flex align-items-center">
												<span>Загружено</span>
												<span className="elipse-separator mx-2"></span>
												<span>{uiState.files.shortFileSize(store.DownloadingSignFile.size)}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="file-card__action ml-auto d-flex align-items-center">
								{store.DownloadingSignFileState !== FileStateEnum.Waiting &&
									<div className="file-card__close">
										{!uiState.IsDisabled &&
											<>
												<button className="btn btn-delete" onClick={() => store.DeleteSign()}>Удалить</button>
												<button className="btn btn-icon icon-delete" onClick={() => store.DeleteSign()}>
													<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M15.8334 5.34167L14.6584 4.16667L10.0001 8.82501L5.34175 4.16667L4.16675 5.34167L8.82508 10L4.16675 14.6583L5.34175 15.8333L10.0001 11.175L14.6584 15.8333L15.8334 14.6583L11.1751 10L15.8334 5.34167Z" />
													</svg>
												</button>
											</>
										}
									</div>
								}
								{store.DownloadingSignFileState === FileStateEnum.Waiting &&
									<div className="waiting d-flex align-items-center justify-content-center">
										<svg className="loader" width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M74.5059 38.5498C74.5059 58.77 58.1704 75.1055 37.9502 75.1055C17.73 75.1055 1.39453 58.77 1.39453 38.5498C1.39453 18.3297 17.8297 1.99414 38.0498 1.99414C58.1704 1.99414 74.5059 18.3297 74.5059 38.5498ZM6.57408 38.5498C6.57408 55.8814 20.6186 69.926 37.9502 69.926C55.2818 69.926 69.3264 55.8814 69.3264 38.5498C69.3264 21.2183 55.3814 7.07409 38.0498 7.07409C20.7183 7.07409 6.57408 21.2183 6.57408 38.5498Z" fill="#CCDDFF"></path>
											<path d="M72.0157 38.5498C73.4102 38.5498 74.6055 37.3545 74.5059 35.96C74.2071 32.0753 73.3106 28.1907 71.8165 24.5052C70.0236 20.1225 67.3342 16.0387 63.9476 12.652C60.5609 9.26539 56.5767 6.57601 52.0944 4.78309C48.4089 3.28898 44.6239 2.39252 40.6396 2.0937C39.2451 1.99409 38.0498 3.18938 38.0498 4.58387C38.0498 5.97837 39.2451 7.17365 40.6396 7.27326C43.827 7.47247 47.0144 8.26932 50.0026 9.4646C53.7877 11.0583 57.2739 13.3493 60.1625 16.2379C63.0511 19.1265 65.4417 22.6127 66.9358 26.3978C68.2307 29.386 68.9279 32.5734 69.2267 35.8604C69.4259 37.3545 70.5216 38.5498 72.0157 38.5498Z" fill="#0057FF"></path>
										</svg>
									</div>
								}
							</div>
						</div>
					</div>
				}
			</div>

		)
	}
)